<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" :show-footer="false" @hide="modal_onhide" destroy-on-close transfer>
			<template #default>
				<el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
					<el-tab-pane label="主流程" name="main" v-if="flowprogressContentMain.length">
						<div
							style="position: relative;box-sizing: border-box;padding: 10px;overflow: auto;height: 400px;">
							<div>
								<el-steps direction="vertical" :active="flowprogressContentMain.length-1" :space="80">
									<el-step v-for="(item,index) in flowprogressContentMain" :key="index"
										:title="item.title" :description="item.time">
									</el-step>
								</el-steps>
							</div>
						</div>
						<div style="float: right;margin-top: 50px;">
<!-- 							<vxe-button size="mini" status="warning" content="取回" @click="retrieve"
								style="margin-right: 10px;" v-if="!isflow">
							</vxe-button> -->
							<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
						</div>
					</el-tab-pane>
					<el-tab-pane v-for="(item,index) in flowprogressContentSon" :label="item.flowname" :name="item.flowname" :key="index">
						<div
							style="position: relative;box-sizing: border-box;padding: 10px;overflow: auto;height: 400px;">
							<div>
								<el-steps direction="vertical" :active="item.content.length-1" :space="80">
									<el-step v-for="(item,index) in item.content" :key="index"
										:title="item.title" :description="item.time">
									</el-step>
								</el-steps>
							</div>
						</div>
						<div style="float: right;margin-top: 50px;">
							<vxe-button size="mini" status="danger" content="撤销" @click="deleteflow(item.flowprogressid)"
								style="margin-right: 10px;" v-if="!isflow">
							</vxe-button>
							<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
						</div>
					</el-tab-pane>
					
				</el-tabs>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			isflow: {
				default: () => {
					return false
				}
			},
			dataid: {
				default: () => {
					return null
				}
			},
			moduleName: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '流程详情',
				modal_width: 600,
				modal_height: 600,
				activeName: null,
				flowprogressContentMain: [],
				flowprogressContentSon: [],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			deleteflow(flowprogressid){
				this.$confirm('是否确认撤销','提示').then(()=>{
					this.$api.flowprogress.delete(flowprogressid,{fource:true}).then(()=>{
						this.$message.success('操作成功')
						this.modal_cancel()
					})
				})				
			},
			handleClick() {

			},
			modal_init() {
				this.activeName = null
				this.flowprogressContentMain = []
				this.flowprogressContentSon = []
				this.dataflow()
			},
			dataflow() {
				// console.log(this.row.id, this.moduleName)
				this.$api.flowprogress.list({
					dataid: this.dataid,
					formname: this.moduleName
				}).then((res) => {
					if (res.length == 0) {
						this.$message.error('暂无流程信息')
					} else {
						let flowprogressgroup = this.$Lodash.groupBy(res, 'flowtemplatetype')
						if (flowprogressgroup.son) {
							flowprogressgroup.son = this.$Lodash.groupBy(flowprogressgroup.son, 'flowtemplateid')
						}
						console.log(flowprogressgroup)
						if(flowprogressgroup.main){
							this.activeName = 'main'
							this.flowprogressContentMain = this.createflowdetail(flowprogressgroup.main)
						}
						if(flowprogressgroup.son){
							for (let i in flowprogressgroup.son) {
								let flowname = flowprogressgroup.son[i][0]['flowname']+'【'+i+'】'
								this.flowprogressContentSon.push({
									flowprogressid: flowprogressgroup.son[i][0]['id'],
									flowname: flowname,
									content: this.createflowdetail(flowprogressgroup.son[i])
								})
								if(!this.activeName){
									this.activeName = flowname
								}
							}
						}


					}
				})

			},
			createflowdetail(flowprogress) {
				let flowprogressContent = []
				flowprogress.forEach((item, index) => {
					if (item.currentnodetype != 3) {
						let time = window.systemMethods.timestampToDate(item.update_time * 1000)
						let currentstaff = window.systemMethods.getstaff(item.currentstaffid)
						let nextstaffid = item.nextstaffid ? item.nextstaffid.toString().split(
								',') :
							null
						let nextstaff = []
						if (nextstaffid) {
							nextstaffid.forEach((item) => {
								nextstaff.push(window.systemMethods.getstaff(item))
							})
						}
						nextstaff = nextstaff.join('，')
						let current = {
							time: time,
							currentstaff: currentstaff,
							tag: item.tag ? item.tag : '',
							submit: item.submit ? item.submit : ''
						}
						let currenttitle = ''
						currenttitle += current.currentstaff
						if (current.tag) {
							currenttitle += '【' + current.tag + '】'
						}
						if (current.submit) {
							currenttitle += '（' + current.submit + '）'
						}
						current.title = currenttitle
						let next = null
						flowprogressContent.push(current)
						if (index == flowprogress.length - 1) {
							if (item.isend != 1) {
								next = {
									time: null,
									currentstaff: nextstaff,
									tag: '待执行',
									submit: ''
								}
							} else {
								next = {
									time: null,
									currentstaff: '',
									tag: '结束',
									submit: ''
								}
							}
						}
						if (next) {
							let nexttitle = ''
							nexttitle += next.currentstaff
							if (next.tag) {
								nexttitle += '【' + next.tag + '】'
							}
							if (next.submit) {
								nexttitle += '（' + next.submit + '）'
							}
							next.title = nexttitle
							flowprogressContent.push(next)
						}

					}
				})
				return flowprogressContent
			},
			retrieve() {
				this.$emit('retrieve')
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>